import React from "react";
import Slider from "../../Constant/Slider";
import StatisticsBar from "../StatisticsBar/StatisticsBar";
import AboutOmnia from "../AboutOmnia/AboutOmnia";
import LogoSlider from "../LogoSlider/LogoSlider";
import { Brands_Data, Certificates_Data } from "../../Constant/Data";
import HorizontalLine from "../../Constant/HorizontalLine";
import IndustriesWeServe from "../IndustriesWeServe/IndustriesWeServe";
import BrandSlider from "../BrandSlider/BrandSlider";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";
import APanIndiaNetwork from "../APanIndiaNetwork/APanIndiaNetwork";
import CallToAction from "../CallToAction/CallToAction";

const Home = () => {
  return (
    <>
      <Slider />
      <StatisticsBar />
      <AboutOmnia />
      <LogoSlider
        data={Certificates_Data}
        title="Certificates"
        desc="Certificates"
      />
      <HorizontalLine />
      <IndustriesWeServe />
      <BrandSlider
        data={Brands_Data}
        title="Brands"
        desc="Leading Steel Brands Working With Us"
      />
      <HorizontalLine />
      <WhyChooseUs />
      <APanIndiaNetwork />
      <CallToAction />
    </>
  );
};

export default Home;
